"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Settings/Security/PasswordForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Form = require('web/components/Form');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _PasswordSection = require('./PasswordSection'); var _PasswordSection2 = _interopRequireDefault(_PasswordSection);
var _app = require('shared/constants/app');














const getInitialState = () => ({
  currentPassword: '',
  newPassword: '',
  newPasswordConfirmation: '',
  isPasswordStrong: false,
})

const PasswordForm = ({ onSubmit }) => {
  const [values, setValues] = _react.useState.call(void 0, getInitialState)

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(values)
    setValues(getInitialState())
  }

  // Stable identities, like the class's instance methods: PasswordInput
  // re-validates whenever onValidated changes, so a new function per render
  // would loop.
  const handleStrengthChange = _react.useCallback.call(void 0, (isPasswordStrong) =>
    setValues(prev => ({ ...prev, isPasswordStrong })), [])
  const handleChange = _react.useCallback.call(void 0, (inputId, value) =>
    setValues(prev => ({ ...prev, [inputId ]: value })), [])

  const {
    isPasswordStrong,
    currentPassword, newPassword, newPasswordConfirmation,
  } = values

  const isFormFilled =
    currentPassword && newPassword && newPasswordConfirmation

  const isConfirmationCorrect = newPassword === newPasswordConfirmation
  const shouldShowMismatchWarning =
    newPassword &&
    newPasswordConfirmation &&
    !isConfirmationCorrect

  return (
    _react2.default.createElement('form', { onSubmit: handleSubmit, className: "settings--account--form", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
      , _react2.default.createElement(_PasswordSection2.default, {
        title: "Current password" ,
        inputId: "currentPassword",
        value: currentPassword,
        onChange: handleChange,
        placeholder: "Enter your current password"   ,
        autoComplete: "current-password", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
      )
      , _react2.default.createElement(_PasswordSection2.default, {
        title: "New password" ,
        inputId: "newPassword",
        value: newPassword,
        onChange: handleChange,
        placeholder: "Enter a new password"   ,
        autoComplete: "new-password",
        onValidated: handleStrengthChange,
        maxLength: _app.MAX_PASSWORD_LENGTH, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
      )
      , _react2.default.createElement(_PasswordSection2.default, {
        title: "Confirm password" ,
        inputId: "newPasswordConfirmation",
        inputClassName: 
          shouldShowMismatchWarning ? 'settings--account--input-invalid' : undefined
        ,
        value: newPasswordConfirmation,
        onChange: handleChange,
        autoComplete: "new-password",
        placeholder: "Confirm your new password"   ,
        maxLength: _app.MAX_PASSWORD_LENGTH, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
      )
      ,  shouldShowMismatchWarning && (
        _react2.default.createElement(_WarningBar2.default, {
          className: "settings--account--warning",
          textClassName: "settings--account--warning-text",
          theme: "warning",
          text: "Your passwords don't match. Make sure you entered your new password correctly."           , __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
        )
      )
      , _react2.default.createElement(_Form.Button, {
        isSubmit: true,
        isDisabled: !isFormFilled || !isPasswordStrong,
        className: "settings--account--submit-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
, "Save"

      )
    )
  )
}

exports. default = PasswordForm
